module.exports = __webpack_public_path__ + "static/img/SmileAnimation_apple.2ab872a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_apple.gif
// module id = qtqs
// module chunks = 0